__turbopack_context__.v({
  "embedded_form": "EmbeddedFrame-module-scss-module__IKVl9a__embedded_form",
});
